import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./navbar/Navbar";
import { Route, Routes } from "react-router-dom";
import About from "./about/About";
import "./home.css";
import Projet from "./projet/Projet";

const Home = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const role = localStorage.getItem("role");
    if (!role) {
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/projet" element={<Projet />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </>
  );
};

export default Home;
